import { Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export const PopoverHeader = (props: { children: ReactNode }): JSX.Element => (
    <Typography style={{ padding: '10px 15px' }} variant='h6'>
        {props.children}
    </Typography>
);
